module.exports = __webpack_public_path__ + "img/splitFileNum2.e58d9153.svg";